// register component(s) with react habitat
// import codeSplit from 'scripts/higher-order-components/codeSplit'
// import l10n from './l10n'
//
// export default {
//   HeroStage: codeSplit({
//     l10n,
//     loadComponent: () =>
//       import(
//         /* webpackChunkName: "HeroStage" */
//         './index'
//       ),
//   }),
// }

import HeroStage from './eager'

export default {
  HeroStage,
}
